var lib_core = require("lib-core");
var cio_datamodel = require("cio-datamodel");
var IpcSmdPadGeneratorInteractionModel = require('../ipcSmdPadGeneratorInteractionModel.js');
var PackageGeneratorInspectorConfig = require("../../packageGeneratorInspectorConfig.js");
var IpcImages = require("../../../../../shared/extensions/footprintGenerator/ipcImages/index.js");

var SodPadGeneratorInteractionModel = function(parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams) {
    IpcSmdPadGeneratorInteractionModel.call(this, parametricData, userSettingsModel, showFootprintParams, withCustomFootprintParams);
};

lib_core.inherit(SodPadGeneratorInteractionModel, IpcSmdPadGeneratorInteractionModel);
SodPadGeneratorInteractionModel.$class = 'SodPadGeneratorInteractionModel';

module.exports = SodPadGeneratorInteractionModel;

SodPadGeneratorInteractionModel.prototype.getInspectorElementForLeadSpan = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D', this.LCLZ('leadSpan', 'Lead Span'), false, this.horizontalLeadToLeadSpanMin, false, this.horizontalLeadToLeadSpanMax, this.userSettingsModel.distanceUnit)];
};

SodPadGeneratorInteractionModel.prototype.getInspectorElementForBodyLength = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('D1', this.LCLZ('bodyLength', 'Body Length'), false, this.bodyWidthMin, false, this.bodyWidthMax, this.userSettingsModel.distanceUnit)];
};

SodPadGeneratorInteractionModel.prototype.getInspectorElementForBodyWidth = function() {
    return [PackageGeneratorInspectorConfig.getMinMaxRow('E', this.LCLZ('bodyWidth', 'Body Width'), false, this.bodyLengthMin, false, this.bodyLengthMax, this.userSettingsModel.distanceUnit)];
};

SodPadGeneratorInteractionModel.prototype.getInspectorElements = function() {
    var imElements = [];
    
    //custom footprint settings
    if (this.withCustomFootprintParams() && this.showFootprintParams()) {
        imElements = imElements.concat(this.getInspectorElementForEnablingCustomFootprint());
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintImage(IpcImages.customFootprintSod));
        imElements = imElements.concat(this.getInspectorElementForCustomFootprintNormalPadSettings());
        imElements = imElements.concat(this.getInspectorElementForPadGapInCustomFootprint());
    };
    imElements = imElements.concat(this.getInspectorElementForPadShape());
    imElements = imElements.concat(this.getInspectorElementForPadRoundness());
    imElements = imElements.concat(this.getInspectorElementForDensityLevel());
    imElements = imElements.concat(this.getInspectorElementForLeadSpan());
    imElements = imElements.concat(this.getInspectorElementForTerminalLength());
    imElements = imElements.concat(this.getInspectorElementForTerminalWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyLength());
    imElements = imElements.concat(this.getInspectorElementForBodyWidth());
    imElements = imElements.concat(this.getInspectorElementForBodyHeight());
    imElements = imElements.concat(this.getInspectorElementForBodyOffset());
    imElements = imElements.concat(this.getInspectorElementForMapping());
    imElements = imElements.concat(this.getInspectorElementForTolerance());

    this.inspectorElements.input_elements = imElements;
    return this.inspectorElements;
};